module.exports = "https://cdn.dove.it/_next/static/public/assets/features/feature_5.0df54fe832dfb0a5749b18aeb25716e5.png";